
import { useState } from 'react';

interface Testimonial {
  id: number;
  name: string;
  title: string;
  content: string;
  image: string;
}

const testimonials: Testimonial[] = [
  {
    id: 1,
    name: '김민지',
    title: '허리 통증이 사라졌어요',
    content: '맞춤 인솔을 사용한 지 2주 만에 만성 허리 통증이 눈에 띄게 줄었습니다. 자세가 교정되면서 일상생활이 훨씬 편해졌어요',
    image: 'https://public.readdy.ai/ai/img_res/454efc91473ccd5d1e955e3a0ef1a1b6.jpg'
  },
  {
    id: 2,
    name: '박준호',
    title: '운동 효율이 높아졌습니다',
    content: '러닝할 때 발의 피로감이 확실히 줄었고, 무릎 통증도 개선되었습니다. 스포츠 인솔 덕분에 더 오래 달릴 수 있게 되었어요',
    image: 'https://readdy.ai/api/search-image?query=Athletic%20Korean%20man%20in%20his%2030s%20in%20sportswear%20showing%20healthy%20posture%20and%20movement%20in%20a%20modern%20gym%20setting.%20Bright%20natural%20lighting%20with%20teal%20and%20mint%20green%20accent%20colors.%20Clean%20fitness%20environment%20demonstrating%20active%20lifestyle.%20Professional%20sports%20photography%20with%20dynamic%20composition&width=600&height=800&seq=testimonial-002&orientation=portrait'
  },
  {
    id: 3,
    name: '이수진',
    title: '하루 종일 서 있어도 편해요',
    content: '서비스직 종사자로서 하루 8시간 이상 서 있는데, 맞춤 인솔 덕분에 발 통증이 사라졌습니다. 정말 감사합니다',
    image: 'https://readdy.ai/api/search-image?query=Professional%20Korean%20woman%20in%20her%2020s%20wearing%20service%20industry%20uniform%20standing%20comfortably%20with%20good%20posture.%20Bright%20and%20clean%20modern%20workplace%20environment%20with%20soft%20teal%20lighting.%20Natural%20smile%20showing%20comfort%20and%20satisfaction.%20Professional%20portrait%20photography%20with%20warm%20atmosphere&width=600&height=800&seq=testimonial-003&orientation=portrait'
  }
];

export default function Testimonials() {
  const [currentIndex, setCurrentIndex] = useState(0);

  const handlePrev = () => {
    setCurrentIndex((prev) => (prev === 0 ? testimonials.length - 1 : prev - 1));
  };

  const handleNext = () => {
    setCurrentIndex((prev) => (prev === testimonials.length - 1 ? 0 : prev + 1));
  };

  return (
    <section id="testimonials" className="py-32 px-16 bg-white">
      <div className="max-w-7xl mx-auto">
        <div className="grid grid-cols-5 gap-12 items-center">
          {/* Left - Image */}
          <div className="col-span-2">
            <div className="rounded-3xl overflow-hidden aspect-[3/4] hover:scale-105 transition-transform duration-500">
            </div>
          </div>

          {/* Right - Content */}
          <div className="col-span-3 space-y-8">
            <p className="text-sm text-gray-500">(고객 후기)</p>
          </div>
        </div>
      </div>
    </section>
  );
}
